// // src/features/ward/wardSlice.js
 
// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import axios from 'axios';
// import { setStatusFail } from '../statusFail/statusFailSlice';
// import Cookies from 'js-cookie';
// const API_BASE_URL = `${process.env.REACT_APP_ADMIN_URL}/buildings`

// export const fetchBuildings = createAsyncThunk(
//   'ward/fetchBuildings',
//   async (locationid,{ rejectWithValue,dispatch }) => {
//     try {
//         const response = await axios.get(API_BASE_URL,{
//           headers: {
//             Authorization: `Bearer ${Cookies.get("Token")}`,
//             "Content-Type": "application/json",
//             locationid
//           }
//         });
//         return response.data.data;
//     } catch (error) {
     
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//              const route = "/status-failed"
//              await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//            }
//            return rejectWithValue(error.response.data?.error?.message || error.response?.data?.message || "Something went wrong");
//     }
   
//   }
// );

// export const createBuilding = createAsyncThunk(
//   'ward/createBuilding',
//   async ({name,locationid},{ rejectWithValue,dispatch }) => {
//     try {
//         const response = await axios.post(API_BASE_URL, { name },
//            { headers: {
//                  Authorization: `Bearer ${Cookies.get("Token")}`,
//                  "Content-Type": "application/json",
//                  locationid
//               },}
//         );
   
//      return response.data.data;
        
//     } catch (error) {
    
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || error.response?.data.message || "Something went wrong");
//     }
    
//   }
// );

// export const addFloor = createAsyncThunk(
//   'ward/addFloor',
//   async ({ buildingId,floors, level },{ rejectWithValue,dispatch }) => {
//     try {
//         const response = await axios.post(`${API_BASE_URL}/${buildingId}/floors`, floors,
//         { headers: {
//           Authorization: `Bearer ${Cookies.get("Token")}`,
//           "Content-Type": "application/json"
//         }});
//         return {data:response.data.data,level};
//     } catch (error) {
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
//     }
  
//   }
// );

// export const addWard = createAsyncThunk(
//   'ward/addWard',
//   async ({ buildingId, floorLevel, name },{ rejectWithValue,dispatch }) => {
//     try { 
//          const response = await axios.post(`${API_BASE_URL}/${buildingId}/floors/${floorLevel}/wards`,
//         { name },
//         { headers: {
//           Authorization: `Bearer ${Cookies.get("Token")}`,
//           "Content-Type": "application/json"
//         }}
//       );
    
//       return {data:response.data.data,floorLevel,name};
//     } catch (error) {
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
//     }
  
//   }
// );

// export const addBeds = createAsyncThunk(
//   'ward/addBeds',
//   async ({ buildingId, floorLevel, wardId, count },{ rejectWithValue,getState,dispatch }) => {
 
//     try {
//       const { buildings } = getState().ward;
//       const building = buildings.find(b => b._id === buildingId);
      
     
//       if (!building) {
//         return rejectWithValue('Building not found');
//       }

//       const floor = building.floors?.find(f => f.level === floorLevel);
   
//       if (!floor) {
//         return rejectWithValue('Floor not found');
//       }

//       const findWard = floor.wards?.find(w => w._id === wardId);
     
//       if (!findWard) {
//         return rejectWithValue('Ward not found');
//       }
//       const beds = Array.from({ length: count }, (_, i) => ({
//         number: findWard.beds.length + i + 1,
//         status: 'available'
//       }));
          
//           const response = await axios.post(`${API_BASE_URL}/${buildingId}/floors/${floorLevel}/wards/${wardId}/beds`,
//             beds,
//             { headers: {
//               Authorization: `Bearer ${Cookies.get("Token")}`,
//               "Content-Type": "application/json"
//             }}
//           );
//           console.log(response)
//           return response.data.data;
//     } catch (error) {
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
//     }
  
//   }
// );

// export const updateBedStatus = createAsyncThunk(
//   'ward/updateBedStatus',
//   async ({ buildingId, floorLevel, wardId, bedId, status },{ rejectWithValue,dispatch }) => {
//     try {
//         const response = await axios.patch(
//             `${API_BASE_URL}/${buildingId}/floors/${floorLevel}/wards/${wardId}/beds/${bedId}`,
//             { status },
//             { headers: {
//               Authorization: `Bearer ${Cookies.get("Token")}`,
//               "Content-Type": "application/json"
//             }}
//           );
//           return response.data.data;
//     } catch (error) {
//       if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
//     }
   
//   }
// );

// const wardSlice = createSlice({
//   name: 'ward',
//   initialState: {
//     buildings: [],
//     selectedBuilding: null,
//     selectedFloor: null,
//     selectedWard: null,
//     selectedBed: null,
//     loading: false,
//     error: null
//   },
//   reducers: {
//     setSelectedBuilding: (state, action) => {
   
//       state.selectedBuilding = action.payload;
//       const building = action.payload ? state.buildings.find(b => b._id === action.payload):null;
//       state.selectedFloor = building?.floors.length > 0 ? building.floors[0].level : null;
//       state.selectedWard =  null;
//       state.selectedBed = null;
//     },
//     setSelectedFloor: (state, action) => {
//       state.selectedFloor = action.payload;
//       const floor = action.payload? state.buildings.find(b => b._id === state.selectedBuilding)?.floors.find(f => f.level === action.payload):null;
//       state.selectedWard = floor?.wards?.length > 0 ? floor.wards[0]._id : null;
//       state.selectedBed = null;
//     },
//     setSelectedWard: (state, action) => {
//       state.selectedWard = action.payload;
//       state.selectedBed = null;
//     },
//     setSelectedBed: (state, action) => {
//       state.selectedBed = action.payload;
//     },
//     clearError: (state) => {
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchBuildings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchBuildings.fulfilled, (state, action) => {
//         state.selectedBuilding =state.selectedBuilding
//         state.buildings = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchBuildings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || 'Failed to fetch buildings';
//       })
//       .addCase(createBuilding.pending, (state, action) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createBuilding.fulfilled, (state, action) => {
//         state.loading = false;
//         state.buildings.push(action.payload);
//         state.selectedBuilding = action.payload._id;
//       })
//       .addCase(createBuilding.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || 'Failed to fetch buildings';
//       })
//       .addCase(addFloor.pending, (state, action) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addFloor.fulfilled, (state, action) => {
//         const index = state.buildings.findIndex(b => b._id === action.payload.data._id);
//         if (index !== -1) {
//           state.buildings[index] = action.payload.data;
//         }
//         state.selectedFloor = action.payload.level;
//         state.loading = false;
//       })
//       .addCase(addFloor.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || 'Failed to fetch buildings';
//       })
//       .addCase(addWard.pending, (state, action) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addWard.fulfilled, (state, action) => {
//         const index = state.buildings.findIndex(b => b._id === action.payload.data._id);
//         if (index !== -1) {
//           state.buildings[index] = action.payload.data;
//         }
//          const floor =  state.buildings[index].floors.find(f => f.level === action.payload.floorLevel);
//         const ward =  floor.wards.find(w => w.name === action.payload.name);
//         state.selectedWard = ward._id;
//         state.loading=false
//       })
//       .addCase(addWard.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || 'Failed to fetch buildings';
//       })
//       .addCase(addBeds.pending, (state, action) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addBeds.fulfilled, (state, action) => {
//         const index = state.buildings.findIndex(b => b._id === action.payload._id);
//         if (index !== -1) {
//           state.buildings[index] = action.payload;
//         }
//         state.loading = false;
//       }).addCase(addBeds.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || 'Failed to fetch buildings';
//       })
//       .addCase(updateBedStatus.fulfilled, (state, action) => {
//         const index = state.buildings.findIndex(b => b.id === action.payload.id);
//         if (index !== -1) {
//           state.buildings[index] = action.payload;
//         }
//         state.selectedBed = null;
//       });
//   },
// });

// export const { 
//   setSelectedBuilding,
//   setSelectedFloor,
//   setSelectedWard,
//   setSelectedBed,
//   clearError
// } = wardSlice.actions;

// export default wardSlice.reducer;

// src/features/ward/wardSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';
import { setStatusFail } from '../statusFail/statusFailSlice';

const API_BASE_URL = `${process.env.REACT_APP_ADMIN_URL}`;

// -------------------- THUNKS --------------------
export const createBuilding = createAsyncThunk(
  'ward/createBuilding',
  async ({ name, locationid }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/buildings`,
        { name },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('Token')}`,
            'Content-Type': 'application/json',
            locationid,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        'Something went wrong'
      );
    }
  }
);

export const fetchBuildings = createAsyncThunk(
  'ward/fetchBuildings',
  async (locationid, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/buildings`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('Token')}`,
          'Content-Type': 'application/json',
          locationid,
        },
      });
      return response.data.data;
    } catch (error) {
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message ||
          error.response?.data?.message ||
          'Something went wrong'
      );
    }
  }
);

export const addFloor = createAsyncThunk(
  'ward/addFloor',
  async ({ buildingId, floors }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/buildings/${buildingId}/floors`,
        floors,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('Token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { buildingId, data: response.data.data };
    } catch (error) {
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || 'Something went wrong'
      );
    }
  }
);

export const fetchFloors = createAsyncThunk(
  'ward/fetchFloors',
  async (buildingId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/buildings/${buildingId}/floors`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('Token')}`,
        },
      });
      return { buildingId, data: response.data.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error?.message || 'Something went wrong');
    }
  }
);


export const addWard = createAsyncThunk(
  'ward/addWard',
  async ({ buildingId, floorId, ward }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/buildings/${buildingId}/floors/${floorId}/wards`,
        ward,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('Token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { buildingId, floorId, data: response.data.data };
    } catch (error) {
      console.error('addWard API error:', error.response?.data || error);
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || 'Something went wrong'
      );
    }
  }
);

export const fetchWards = createAsyncThunk(
  'ward/fetchWards',
  async (floorId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/buildings/floors/${floorId}/wards`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('Token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { floorId, data: response.data.data };
    } catch (error) {
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || 'Something went wrong'
      );
    }
  }
);

export const addBeds = createAsyncThunk(
  'ward/addBeds',
  async ({ buildingId, floorId, wardId, beds }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/buildings/${buildingId}/floors/${floorId}/wards/${wardId}/beds`,
        beds,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('Token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { buildingId, floorId, wardId, data: response.data.data };
    } catch (error) {
      if (error.response?.data?.errorCode === 'STATUS_CHECK_TENANT_DENIED') {
        const route = '/status-failed';
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || 'Something went wrong'
      );
    }
  }
);

export const fetchBeds = createAsyncThunk(
  "ward/fetchBeds",
  async ({ wardId, currentPage, itemsPerPage, sortBy, order }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/buildings/wards/${wardId}/beds`,
        {
          params: {
            page: currentPage,
            limit: itemsPerPage,
            sortBy,
            order,
          },
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      const { data, totalCount, totalPages, page, limit, sortBy: resSortBy, order: resOrder } = response.data.data;
      return {
        data,
        totalCount,
        totalPages,
        page,
        limit,
        sortBy: resSortBy,
        order: resOrder,
      };
    } catch (error) {
      if (error.response?.data?.errorCode === "STATUS_CHECK_TENANT_DENIED") {
        const route = "/status-failed";
        await dispatch(
          setStatusFail({ tenants: error.response.data.tenants, navigate: route })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || "Something went wrong while fetching beds."
      );
    }
  }
);

export const fetchAllBookedBeds = createAsyncThunk(
  'bed/fetchAllBookedBeds',
  async (locationId, { rejectWithValue }) => {
    try {
      // Occupancy now comes from the IPD bed board; flatten it to the { bed, patient } shape the ward view merges.
      const response = await axios.get(`${API_BASE_URL}/ipd/beds`, {
        params: { locationId },
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return (response.data.data?.buildings || [])
        .flatMap((b) => b.floors || [])
        .flatMap((f) => f.wards || [])
        .flatMap((w) => w.beds || [])
        .filter((bed) => bed.admission)
        .map((bed) => {
          // Keep the { age, phone } shape the bed card was written for.
          const { dob, phoneNumber, ...patient } = bed.admission.patient || {};
          const age = dob ? Math.floor((Date.now() - new Date(dob)) / (365.25 * 24 * 3600 * 1000)) : undefined;
          return { bed: { _id: bed._id }, patient: { ...patient, age, phone: phoneNumber } };
        });
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.message || 'Something went wrong while fetching booked beds.'
      );
    }
  }
);

// -------------------- SLICE --------------------
const wardSlice = createSlice({
  name: 'ward',
  initialState: {
    buildings: [],
    selectedBuilding: null,
    selectedFloor: null,
    selectedWard: null,
    selectedBed: null,
    bookedBed: null,
    beds: {
      data: [],
      totalCount: 50,
      totalPages: 5,
      currentPage: 1,
      limit: 10,
      sortBy: "createdAt",
      order: "desc",
    },
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedBuilding: (state, action) => {
      state.selectedBuilding = action.payload;
      const building = state.buildings.find((b) => b._id === action.payload);
      state.selectedFloor = building?.floors?.[0]?._id || null;
      state.selectedWard = null;
      state.selectedBed = null;
    },
    setSelectedFloor: (state, action) => {
      state.selectedFloor = action.payload;
      const building = state.buildings.find((b) => b._id === state.selectedBuilding);
      const floor = building?.floors?.find((f) => f._id === action.payload);
      state.selectedWard = floor?.wards?.[0]?._id || null;
      state.selectedBed = null;
    },
    setSelectedWard: (state, action) => {
      state.selectedWard = action.payload;
      state.selectedBed = null;
    },
    setSelectedBed: (state, action) => {
      state.selectedBed = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch buildings
      .addCase(fetchBuildings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuildings.fulfilled, (state, action) => {
        state.buildings = action.payload;
        state.loading = false;
      })
      .addCase(fetchBuildings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create building
      .addCase(createBuilding.fulfilled, (state, action) => {
        state.buildings.push(action.payload);
        state.selectedBuilding = action.payload._id;
        state.loading = false;
      })

      // Add floor
      .addCase(addFloor.fulfilled, (state, action) => {
        const index = state.buildings.findIndex((b) => b._id === action.payload.buildingId);
        if (index !== -1) {
          state.buildings[index] = action.payload.data;
        }
        state.loading = false;
      })
      
      // fetch Floor
      .addCase(fetchFloors.fulfilled, (state, action) => {
        const { buildingId, data } = action.payload;
        const building = state.buildings.find((b) => b._id === buildingId);
        if (building) {
          building.floors = data;
        }
      })

      // Add ward
      .addCase(addWard.fulfilled, (state, action) => {
        const index = state.buildings.findIndex((b) => b._id === action.payload.buildingId);
        if (index !== -1) {
          state.buildings[index] = action.payload.data;
          
          const building = state.buildings[index];
          const floor = building?.floors?.find((f) => f._id === action.payload.floorId);
          if (floor && floor.wards?.length > 0) {
            state.selectedWard = floor.wards[floor.wards.length - 1]._id;
          }
        }
        state.loading = false;
      })

      // Fetch wards
      .addCase(fetchWards.fulfilled, (state, action) => {
        const floor = state.buildings
        .flatMap((b) => b.floors || [])
        .find((f) => f._id === action.payload.floorId);

        if (floor) {
          floor.wards = action.payload.data;
        }
        state.loading = false;
      })

      // Add beds
      .addCase(addBeds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBeds.fulfilled, (state, action) => {
        const index = state.buildings.findIndex((b) => b._id === action.payload.buildingId);
        if (index !== -1) {
          state.buildings[index] = action.payload.data;
        }
        state.loading = false;
      })
      .addCase(addBeds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch beds
      .addCase(fetchBeds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBeds.fulfilled, (state, action) => {
        state.loading = false;
        const { data, totalCount, totalPages, page, limit, sortBy, order } = action.payload;
        state.beds = {
          data: data || [],
          totalCount: totalCount || 0,
          totalPages: totalPages || 0,
          currentPage: page || 1,
          limit: limit || 10,
          sortBy: sortBy || "number",
          order: order || "asc",
        };

        console.log(state.beds, "bedsState");
      })
      .addCase(fetchBeds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchAllBookedBeds
      .addCase(fetchAllBookedBeds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBookedBeds.fulfilled, (state, action) => {
        state.loading = false;
        state.bookedBed = action.payload;
      })
      .addCase(fetchAllBookedBeds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    },
  });

export const {
  setSelectedBuilding,
  setSelectedFloor,
  setSelectedWard,
  setSelectedBed,
  clearError,
} = wardSlice.actions;

export default wardSlice.reducer;
